export default "__VITE_ASSET__CuwI1TSo__"